import Errored from '../Errored';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { default as React } from 'react';
import AddButton from '../AddButton';
import CancelButton from '../CancelButton';
import PrimaryButton from '../PrimaryButton';
import { globalStyles as styles } from '../style/gstheme';
import TitledTextField from '../TitledTextField';
import { MAX_IRI_LENGTH } from '../utils/constants';
import { sanitiseText, detailedCheckIRI } from '../utils/utils';

class TrustedDomainDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            isValidIRI: false,
            iri: "",
            isErrored: null
        };
    }

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    componentWillUnmount() {
        if (this.cancellable) this.cancellable.cancel();
    }

    addDomain = async () => {
        this.props.onAddDomain(this.state.iri);
        this.exitAddDomain();
    };

    exitAddDomain = () => {
        this.setState({
            open: false,
            iri: ""
        });
    };

    handleIRIChange = event => {
        const t = event.target;
        const text = sanitiseText(t.value.trim());
        this.setState({
            isValidIRI: false,
            iri: text
        }, () => {
            const isDuplicateIRI = this.props.domains.some(d => d === text);
            // Only allow one hash at most
            let isValidIRI = true;
            if (text.length === 0 || !detailedCheckIRI(text)) {
                isValidIRI = false;
            }
            if (text.toLowerCase().includes("graphifi")) isValidIRI = false;
            this.setState({
                isValidIRI,
                isDuplicateIRI
            });
        });
    };

    render() {

        const { classes } = this.props;
        const { iri, isValidIRI, isDuplicateIRI, isErrored } = this.state;

        if (isErrored) return <Errored data={isErrored} />;

        return (
            <React.Fragment>
                <AddButton dataTest="add-domain" title="Add trusted domain" onClick={this.handleClickOpen} />
                <Dialog
                    data-test="add-iri-dialog"
                    maxWidth="md"
                    fullWidth
                    classes={{
                        paper: classes.paper,
                        paperWidthMd: classes.mediumDialog
                    }}
                    open={this.state.open}
                    onClose={this.exitAddDomain}
                    aria-labelledby="domain-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="domain-dialog-title">Add Trusted Domain</DialogTitle>
                    <DialogContent>
                        <form autoComplete="off" noValidate="novalidate">
                            <TitledTextField
                                dataTest="iri"
                                name="iri"
                                title="IRI"
                                autoFocus={true}
                                margin={true}
                                required={true}
                                text={iri}
                                placeholder="Enter an IRI"
                                maxLength={MAX_IRI_LENGTH}
                                helperText={
                                    iri !== "" && !isValidIRI ?
                                        "This is not a valid IRI"
                                        :
                                        isDuplicateIRI ?
                                            "This IRI already exists. Please change."
                                            :
                                            ""}
                                onChange={this.handleIRIChange} />
                        </form>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={this.exitAddDomain} />
                        <PrimaryButton
                            disabled={!isValidIRI || isDuplicateIRI || iri === ""}
                            onClick={this.addDomain}>Add</PrimaryButton>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

TrustedDomainDialog.defaultPros = {
    domains: []
};

TrustedDomainDialog.propTypes = {
    domains: PropTypes.array,
    onAddDomain: PropTypes.func.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(TrustedDomainDialog);